import { useState } from 'react';

export function useQueryState<T = string>(
  key: string,
  initDefault: T,
  decoder: (v: string) => T,
  encoder: (v: T) => string,
): [T, (v: T) => void] {
  const [current, onUpdate] = useState(() => {
    const url = new URL(window.location.href);
    if (!url.searchParams.has(key)) {
      return initDefault;
    }
    const urlValue = url.searchParams.get(key) || '';
    return decoder(urlValue);
  });
  function update(newValue: T) {
    onUpdate(newValue);
    const url = new URL(window.location.href);
    url.searchParams.set(key, encoder(newValue));
    history.replaceState({ [key]: newValue }, '', url.href);
  }
  return [current as T, update];
}

export function useQueryString(key: string, initDefault: string = '') {
  return useQueryState(
    key,
    initDefault,
    v => v,
    v => v,
  );
}

export function useQueryNumber(key: string, initDefault: number = 0) {
  return useQueryState(
    key,
    initDefault,
    v => (v ? parseInt(v, 10) : 0),
    v => String(v),
  );
}

export function useQueryFlag(key: string, initDefault: boolean = false) {
  function parseBoolean(v: string): boolean {
    if (!v || v === '' || v === 'false' || v === '0') {
      return false;
    }
    return true;
  }
  return useQueryState<boolean>(key, initDefault, parseBoolean, v =>
    v ? '1' : '0',
  );
}
